import { MaterialOverviewElementType } from "@/getData/getIndexedMaterialOverviewData";
import { FileType } from "@/types/baseTypes";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { MediaItemResponsive } from "@/components/MediaItem/MediaItemResponsive";
import { LineChart } from "@/components/LineChart/LineChart";
import { Button } from "@/components/Button/Button";
import { downloadFile } from "@/utils/downloadFile";
import styles from "./MaterialCard.module.scss";
import { OptionsFactsheetsType } from "@/types/OptionType";
import { getFactsheetFromOptions } from "@/utils/getFactsheet";

interface MaterialCardProps {
  element: MaterialOverviewElementType;
  metalCsvFile: FileType;
  headingLevel: number;
  index: number;
  factsheets: OptionsFactsheetsType;
}

export const MaterialCard = ({
  element,
  metalCsvFile,
  headingLevel,
  index,
  factsheets,
}: MaterialCardProps) => {
  const { getLabel } = useGlobalContext();
  const factsheet = element?.factsheet;
  const pdf = factsheet ? getFactsheetFromOptions(factsheet, factsheets) : null;
  return (
    <div
      className={`${styles["material-card"]} ${index % 2 !== 0 ? styles["is-alternate"] : ""}`}
    >
      <div className={`${styles["info-section"]} is-box`}>
        <span
          role="heading"
          aria-level={headingLevel}
          className={styles["title"]}
        >
          {element.title}
        </span>

        {element.table && element.table.length > 0 && (
          <dl className={styles["info-table"]}>
            {element.table.map((row, idx) => (
              <div key={idx} className={styles["info-row"]}>
                <dt className={styles["info-label"]}>{row.information}</dt>
                <dd className={styles["info-value"]}>{row.value}</dd>
              </div>
            ))}
          </dl>
        )}

        {element.link && element.has_single_page && (
          <div className={styles["button-wrapper"]}>
            <Button type="secondary" href={element.link} target="_self">
              {getLabel("learn_more", "Mehr Erfahren")}
            </Button>
          </div>
        )}

        {element.show === "buy-link" && element.shopLink && (
          <div className={styles["button-wrapper"]}>
            <Button
              type="secondary"
              href={element.shopLink.url}
              target={element.shopLink.target}
              aria-label={element.shopLink.aria_label}
            >
              {element.shopLink.title ||
                getLabel("learn_more", "Mehr Erfahren")}
            </Button>
          </div>
        )}
      </div>

      <div className={styles["media-section"]}>
        <div className={styles["image-wrapper"]}>
          {element.image && (
            <MediaItemResponsive
              image_desktop={element.image}
              sizes="(max-width: 767px) 50vw, (max-width: 1023px) 100vw, (max-width: 1407px) 40vw, 640px"
              objectFit="cover"
              hasOverlay={false}
            />
          )}
        </div>

        {element.show === "pdf" && pdf && (
          <div className={styles["bottom-bar"]}>
            <div>
              {/* {pdf && ( */}
              <Button
                aria-label={getLabel("aria_label_factsheet_btn").replace(
                  "$title",
                  pdf.name,
                )}
                type="primary"
                onClick={() => {
                  const url = pdf.file.url;
                  if (url) downloadFile(url).catch((e) => console.error(e));
                }}
                href="_self"
                target="_self"
                animation="none"
                isDownload
                className="mt-0"
              >
                <span>
                  <span className={styles["download-prefix"]}>
                    {getLabel("download_label", "Download")}&nbsp;
                  </span>

                  {getLabel("factsheet_label", "Factsheet")}
                </span>
              </Button>
              {/* )} */}
            </div>

            <LineChart
              className={styles["chart-wrapper"]}
              url={metalCsvFile.url}
              name={element.name}
              min={element.minMax?.min || undefined}
              max={element.minMax?.max || undefined}
            />
          </div>
        )}
      </div>
    </div>
  );
};
